import { useNavigate } from 'react-router-dom';
import { Avatar, Dropdown, Button } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import type { MenuProps } from 'antd';
import './header.less';
import { useUserStore } from '@/store/userStore';
import { useLogout } from '@/hooks/hooksIndex';
import { useEffect, useState } from 'react';
import { getImageUrl } from '@/utils/cos';
import { useLayoutStore } from '@/store/layoutStore';
import { useIsMobile } from '@/hooks/useIsMobile';

// 头部
export const Header = () => {
	const navigate = useNavigate();
	const { userInfo } = useUserStore();
	const logout = useLogout();
	const [profileUrl, setProfileUrl] = useState('');
	const [loading, setLoading] = useState(false);
	const { setCollapsed } = useLayoutStore();
	const isMobile = useIsMobile();
	const handleBackHome = () => {
		navigate('/');
		// 隐藏侧边栏
		if (isMobile) {
			setCollapsed(true);
		}
	};

	useEffect(() => {
		const loadImageUrl = async () => {
			if (!userInfo?.profile) {
				setProfileUrl('');
				return;
			}

			setLoading(true);
			try {
				// 判断key是否以/profile/开头,如果不是,则拼接
				let key = userInfo.profile;
				if (!key.startsWith('profiles/')) {
					key = '/profiles/' + key;
				}
				const url = await getImageUrl(decodeURIComponent(key));
				if (url) {
					const viewUrl = url +
						(url.includes('?') ? '&' : '?') +
						'response-content-disposition=inline' +
						'&imageMogr2/format/avif';
					
					setProfileUrl(viewUrl);
				}
			} catch (error) {
				console.error('Error loading profile image:', error);
				setProfileUrl('');
			} finally {
				setLoading(false);
			}
		};

		loadImageUrl();
	}, [userInfo?.profile]);

	// 用户菜单项
	const userMenuItems: MenuProps['items'] = [
		{
			key: 'profile',
			label: userInfo?.name || userInfo?.phoneNumber || '个人中心',
		},
		{
			key: 'settings',
			label: '我的',
		},
		{
			type: 'divider',
		},
		{
			key: 'logout',
			label: '退出登录',
			danger: true,
		},
	];

	const handleMenuClick: MenuProps['onClick'] = ({ key }) => {
		if (key === 'logout') {
			logout();
		} else {
			navigate(`/user/${key}`);
		}
	};

	return (
		<div className="headerContainer">
			<div className="logo" onClick={handleBackHome}>
				<img src="/logo.svg" alt="logo" />
			</div>
			<div className="rightSection">
				{userInfo ? (
					<Dropdown 
						menu={{ 
							items: userMenuItems,
							onClick: handleMenuClick
						}} 
						placement="bottomRight"
						arrow
					>
						<div className="avatarContainer">
							<Avatar 
								size={32}
								src={profileUrl ? <img src={profileUrl} alt="avatar" /> : null}
								icon={(!profileUrl || loading) && <UserOutlined />}
								style={{ 
									backgroundColor: !profileUrl ? '#1890ff' : undefined,
									cursor: 'pointer'
								}} 
							/>
						</div>
					</Dropdown>
				) : (
					<Button type="link" onClick={() => navigate('/user/login')}>
						登录/注册
					</Button>
				)}
			</div>
		</div>
	);
};
